// extracted by mini-css-extract-plugin
module.exports = {"container":"CTASection_container__1Gkri","section-title":"CTASection_section-title__23rot","content":"CTASection_content__2VXH2"};